import api from '@/services/Api';
import { ActionContext, Module } from 'vuex';
import Text from '@/types/Text';
import { successSwal } from '@/helper/swals';
import { RootState, TexteState } from '@/store/types';

export type TexteFilter = { gueltig: string };
export type LoadTextePayload = { filter: TexteFilter };
export type UpdateTextPayload = { text: Text; filter: TexteFilter };
export type DeleteTextPayload = { text: Text; filter: TexteFilter };

type Context = ActionContext<TexteState, RootState>;

export const texte: Module<TexteState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            texte: false,
        },
        texte: [],
    },
    actions: {
        loadTexte({ commit }: Context, payload?: LoadTextePayload): void {
            commit('setLoadersTexte', true);

            api.post('verwaltung/texte/load', payload)
                .then((response) => commit('setTexte', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersTexte', false));
        },
        updateText({ commit, dispatch }: Context, { text, filter }: UpdateTextPayload): void {
            commit('setLoadersSave', true);

            api.post('verwaltung/texte/speichern', text)
                .then(() => {
                    successSwal('Text', 'gespeichert');
                    dispatch('loadTexte', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteText({ commit, dispatch }: Context, { text, filter }: DeleteTextPayload): void {
            commit('setLoadersDelete', true);

            api.post('verwaltung/texte/loeschen', text)
                .then(() => {
                    successSwal('Text', 'gelöscht');
                    dispatch('loadTexte', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
    },
    mutations: {
        setTexte(state: TexteState, texte: Text[]): void {
            state.texte = texte;
        },
        setDialogsDetail(state: TexteState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: TexteState, loading: boolean): void {
            state.loaders.save = loading;
        },
        setLoadersDelete(state: TexteState, loading: boolean): void {
            state.loaders.delete = loading;
        },
        setLoadersTexte(state: TexteState, loading: boolean): void {
            state.loaders.texte = loading;
        },
    },
};
